import React from 'react';
import Drawer from './Drawer';
import { DrawerToggleButton } from './components';

export interface DrawerWithToggleProps {
  children: React.ReactNode;
  open?: boolean;
  onClose?: () => void;
  anchor?: 'left' | 'right' | 'top' | 'bottom';
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'base';
  hideBackdrop?: boolean;
  clickOutside?: boolean;
  showCloseButton?: boolean;
  showToggleButton?: boolean;
  toggleButtonPosition?: 'start' | 'center' | 'end';
  className?: string;
  variant?: 'temporary' | 'persistent';
}

const DrawerWithToggle: React.FC<DrawerWithToggleProps> = ({
  children,
  open: open,
  onClose,
  anchor = 'right',
  size = 'md',
  hideBackdrop = false,
  clickOutside = true,
  showCloseButton = false,
  showToggleButton = true,
  toggleButtonPosition = 'start',
  className = '',
  variant = 'temporary',
}) => {
  return (
    <div className="relative transition-all duration-300">
      {showToggleButton && anchor === 'left' && (
        <DrawerToggleButton
          isOpen={open}
          onClick={onClose}
          anchor={anchor}
          position={toggleButtonPosition}
          className="absolute"
        />
      )}
      <Drawer
        isOpen={open}
        onClose={onClose}
        anchor={anchor}
        size={size}
        hideBackdrop={hideBackdrop}
        clickOutside={clickOutside}
        showCloseButton={showCloseButton}
        className={className}
        variant={variant}
      >
        {children}
      </Drawer>
      {showToggleButton && anchor === 'right' && (
        <DrawerToggleButton
          isOpen={open}
          onClick={onClose}
          anchor={anchor}
          position={toggleButtonPosition}
          className="absolute"
        />
      )}
    </div>
  );
};

export default DrawerWithToggle;
